import React from "react";

export default (props) => {
  const { iconName, className, title, viewBox } = props;

  let link = `/assets/img/icons.svg#${iconName}`;

  return (
    <React.Fragment>
      <svg
        className={`icon icon--${iconName} ${className ? className : ""}`}
        viewBox={viewBox}
      >
        <title>{title || ""}</title>
        <use href={link} xlinkHref={link} alt=""></use>
      </svg>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Common/Icon.js